import MultipleChoiceQuestion from './MultipleChoiceQuestion';

export default class QuestionModel {
  constructor(data) {
    if (!data) {
      data = {};
    }

    this.required = data.required
    this.optional = !this.required
    this.free_text = data.free_text
    this.multiple_choice = data.multiple_choice ? new MultipleChoiceQuestion(data.multiple_choice) : null;
    this.star_rating = data.star_rating

    this.question_text = data.question_text || '';
    this.slug = data.slug || '';
  }
}
